import { memo, useEffect } from 'react';
import { useCookieConsent } from '~/shared/hooks';
import { useIsViabillEnabled, VIABILL_SCRIPT_ID, VIABILL_SCRIPT_URL } from './viabill.config';

const ViabillScriptComponent = () => {
    const isEnabled = useIsViabillEnabled();
    const { functional, statistic, marketing } = useCookieConsent();

    useEffect(() => {
        if (!isEnabled) {
            return;
        }

        const cookiesEnabled = ['necessary'];
        if (functional) cookiesEnabled.push('functional');
        if (statistic) cookiesEnabled.push('statistical');
        if (marketing) cookiesEnabled.push('marketing');

        // ViaBill reads options on load and observes later pushes; never reassign the array.
        window.viabillOptions = window.viabillOptions || [];
        window.viabillOptions.push({ 'pricetag.cookiesEnabled': cookiesEnabled });

        if (document.getElementById(VIABILL_SCRIPT_ID)) {
            return;
        }

        const script = document.createElement('script');
        script.id = VIABILL_SCRIPT_ID;
        script.type = 'text/javascript';
        script.async = true;
        script.src = VIABILL_SCRIPT_URL;
        document.body.appendChild(script);
    }, [isEnabled, functional, statistic, marketing]);

    return null;
};

export const ViabillScript = memo(ViabillScriptComponent);
ViabillScript.displayName = 'ViabillScript';
